var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('textarea',_vm._b({staticClass:"f-form-textarea f-block f-w-full f-border-gray-300 focus:f-outline-none f-rounded-md f-text-gray-700",class:{
    'f-border-red-300 focus:f-ring-red-500 focus:f-border-red-500 f-text-red-900 f-placeholder-red-300':
      _vm.error,
  },attrs:{"rows":"2"},domProps:{"value":_vm.value},on:{"blur":function($event){return _vm.$emit('input', $event.target.value)}}},'textarea',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }